import React, {
    useState,
    useEffect,
    Fragment,
    useCallback,
    useMemo,
} from 'react';
import { useMediaQuery } from 'react-responsive';

import Traductor from '../../../Traductor';

import SelectInput from '../../common/SelectInput';
import TextInput from '../../common/TextInput';
import DateInput from '../../common/DateInput';
import { withCookies } from 'react-cookie';
import { disableHTMLOverflow } from '../../../../Functions';
import {
    Busqueda,
    dateStart,
    dateEnd,
    status,
    Solicitante,
    channelCode,
} from '../../../../constants/Filters';

function SearchTicketFilters({
    values,
    onChange,
    onFilter,
    classFilters,
    inputSelects,
    getAllSelects,
    setPage,
    currentPage,
    setFilters,
}) {
    const t = useMemo(() => new Traductor(), []);
    const isTabletOrMobile = useMediaQuery({
        query: '(max-device-width: 960px)',
    });

    useEffect(() => {
        getAllSelects();
    }, [getAllSelects]);

    useEffect(() => {
        if (currentPage === 1) {
            onFilter(values);
        } else {
            setFilters(values);
            setPage(1);
        }
    }, [values]);

    useEffect(() => {
        if (classFilters === '') {
            disableHTMLOverflow(true);
            window.bronson.ComponentRegister.initAll();
            if (document.body.clientWidth <= 768)
                window.bronson.$$('.js-accordion').component('accordion');
        }
    }, []);

    const accordionRender = useCallback(() => {
        if (window.innerWidth < 720) {
            setTimeout(function () {
                window.bronson.ComponentRegister.initAll();
            }, 0);
            return 'c-accordion  js-accordion  js-is-fx';
        } else {
            return '';
        }
    }, []);

    const infoPlaceHolder = () => {
        return (
            <h6 className="c-accordion__title">
                <label className="c-accordion__title-label-text ">
                    {t.getTraduction('TicketInfoSearcher')}
                </label>
            </h6>
        );
    };

    return (
        <div
            className={
                isTabletOrMobile
                    ? ''
                    : 'o-layout__item u-1/6 u-3/12@l u-hide@m u-ticket_max_width'
            }
        >
            <div className="c-vehicle-filters">
                <div className="c-accordion" data-accordion-multiple="true">
                    {/*NºTicket*/}
                    <div
                        className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                        style={{
                            paddingBottom: '10px',
                            paddingLeft: '0px',
                        }}
                    >
                        <h5>{t.getTraduction('TicketSearcher')}</h5>
                        {infoPlaceHolder()}
                        <TextInput
                            label={''}
                            name={Busqueda}
                            values={values}
                            onChange={onChange}
                            onBlur={onFilter}
                            row
                            placeHolder=""
                            buscador={true}
                            // classPlaceholder={'u-placeholder_input_text_ticket'}
                        />
                    </div>
                    {/*Date min */}
                    <h5>{t.getTraduction('TicketCreationDate')}</h5>
                    <DateInput
                        label={t.getTraduction('Desde')}
                        row
                        onChange={onChange}
                        onFilter={onFilter}
                        name={dateStart}
                        values={values}
                    />
                    {/*Date max */}
                    <DateInput
                        label={t.getTraduction('Hasta')}
                        row
                        name={dateEnd}
                        onChange={onChange}
                        onFilter={onFilter}
                        values={values}
                    />

                    {/* Status*/}
                    <div
                        className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title"
                        style={{ paddingTop: '20px', paddingLeft: '0px' }}
                    >
                        <h5>{t.getTraduction('Status')}</h5>
                        <SelectInput
                            options={inputSelects.selectStates.map(
                                (state, i) => {
                                    return {
                                        value: state.Value,
                                        label: state.Text,
                                    };
                                }
                            )}
                            label={''}
                            onChange={onChange}
                            onFilter={onFilter}
                            name={status}
                            values={values}
                            row
                        />
                        {/*Solicitante */}
                        <h5>{t.getTraduction('Solicitante')}</h5>
                        <TextInput
                            label={''}
                            name={Solicitante}
                            onChange={onChange}
                            onBlur={onFilter}
                            values={values}
                            row
                            placeHolder=""
                            buscador={true}
                        />
                        {/*Channel-Code */}
                        <h5>{t.getTraduction('Concesionario')}</h5>
                        <SelectInput
                            options={inputSelects.selectConces.map(
                                (conces, i) => {
                                    return {
                                        value: conces.Value,
                                        label: conces.Text,
                                    };
                                }
                            )}
                            label={''}
                            onChange={onChange}
                            onFilter={onFilter}
                            name={channelCode}
                            values={values}
                            row
                        />
                    </div>
                </div>
            </div>
            {/*}
            <div className="u-text-center u-mt-large">
            <button className="c-btn" onClick={AdvancedFilters.openAdvancedFilters} >
              {t.getTraduction("AdvancedFilters")}
            </button>
          </div>
                */}
        </div>
    );
}

export default withCookies(SearchTicketFilters);
